<template>
  <div
    :ref="_uid"
    class="navigation-block"
  >
    <slot />
    <div
      class="navigation-block__inner"
      :class="rowClass"
    >
      <navigation-block
        v-for="(item, index) in navigationBlocks"
        v-show="showMoreLimit === 0 || index < newLimit"
        :key="index"
        v-no-edit
        v-bind="item"
        :display-image-state="displayImageState"
      />
    </div>
    <show-more
      v-if="newLimit < navigationBlocks.length & showMoreLimit !== 0"
      :tracking="{
        event: 'navigationBlockShowMore'
      }"
      @showMoreResult="showMoreAll ? addedItems = 1000 : addedItems += showMoreLimit"
    />
  </div>
</template>

<script>
import showMore from '@/vue/components/common/showMore'

export default {
  name: 'NavigationBlocks',
  components: {
    showMore
  },
  props: {
    navigationHeading: {
      type: String,
      default: ""
    },
    navigationBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    // If show more should be used, this sets where the break will be. If 0, no show more will be used and all items are visible from start.
    showMoreLimit: {
      type: Number,
      default: 0
    },
    // If true, the first show more click will reveal all remaining items. If false, the showMoreLimit will be used per click.
    showMoreAll: {
      type: Boolean,
      default: true
    },
    displayImageState: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      addedItems: 0
    }
  },
  computed: {
    newLimit () {
      return this.showMoreLimit + this.addedItems
    },
    rowClass () {
      const nrOfNavigationBlocks = this.navigationBlocks.length
      const rowOfThreeHoles = nrOfNavigationBlocks%3 === 0 ? 0 : 3 - nrOfNavigationBlocks%3
      const rowOfFourHoles = nrOfNavigationBlocks%4 === 0 ? 0 : 4 - nrOfNavigationBlocks%4

      if (this.limit !== 0) {
        return nrOfNavigationBlocks > 3 ? 'row-1_lg-4_md-2' : 'row-1_lg-3_md-2'
      }

      if (rowOfThreeHoles < rowOfFourHoles) {
        return 'row-1_lg-3_md-2'
      }

      return 'row-1_lg-4_md-2'
    }
  },
  watch: {
    showLimit (newVal, oldVal) {
      // Wait for dom to settle and then focus on the first new item that is visible after show more (accessibility reasons)
      this.$nextTick(() => {
        const component = this.$refs[this._uid]
        const diff = this.navigationBlocks.length - oldVal
        const el = component.querySelector(`.navigation-block__inner > *:nth-last-of-type(${diff}) a`)

        if (el) {
          el.focus()
        }
      })
    }
  },
}
</script>

<style lang="scss">
  .navigation-block {
    @include default-margin();

    &__heading {
      margin: 1rem 0;
    }

    & .navigation-block__inner {
      margin-bottom: -0.5rem;

      @include media-breakpoint-up(md) {
        margin-bottom: -1rem;
      }
    }
  }
</style>
